import { promotionConfigConstants } from './Promotion.constants';

const initialState = {
  appliedFilters: {},
  promotionSummary: { loading: false, error: false, data: [] }
};

// --- Reducer function to set applied filters
const appliedFiltersReducer = (state = initialState.appliedFilters, action) => {
  if (action.filterType === promotionConfigConstants.RESET_FILTERS) {
    return initialState.appliedFilters;
  }
  return { ...state, [action.filterType]: action.payload };
};

const CustomDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // ---- Edit dashboard status
    case promotionConfigConstants.UPDATE_FILTER_REQUEST:
      const appliedFilters = appliedFiltersReducer(state.appliedFilters, action);
      return {
        ...state,
        appliedFilters
      };

    case promotionConfigConstants.UPDATE_FILTER_MULTIPLE:
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.payload
        }
      };

    case promotionConfigConstants.GET_PROMOTION_SUMMARY_REQUEST:
      return {
        ...state,
        promotionSummary: { loading: true, error: false, data: {} }
      };

    case promotionConfigConstants.GET_PROMOTION_SUMMARY_SUCCESS:
      return {
        ...state,
        promotionSummary: { loading: false, error: false, data: action.payload }
      };

    case promotionConfigConstants.GET_PROMOTION_SUMMARY_ERROR:
      return {
        ...state,
        promotionSummary: { loading: false, error: true, data: {} }
      };

    default:
      return state;
  }
};

export default CustomDashboardReducer;
